<script setup lang="ts">
import { SeatType } from '@/api/generated/api.enum';
import { useBillingState } from '@/composables/billing/useBillingState';
import IconButton from '@/core/elements/IconButton.vue';
import UserAvatar from '@/core/UserAvatar.vue';
import { IGenericUser } from '@/interfaces';
import { EIcon } from 'common/enum/misc.enum';
import { computed, toRefs } from 'vue';
import NoSeatsAvailableForInvitation from '../elements/NoSeatsAvailableForInvitation.vue';

const emit = defineEmits<{
  'click:add': [value: IGenericUser];
  'click:remove': [value: IGenericUser];
  'click:link': [value: IGenericUser];
}>();

const props = defineProps<{
  email: string;
  type: 'add';
  disabled?: boolean;
}>();
const { email, type, disabled } = toRefs(props);
const { hasSeatsAvailable } = useBillingState();

const canAdd = computed<boolean>(() => {
  return !disabled.value && hasSeatsAvailable(SeatType.user);
});
</script>

<template>
  <div
    class="list-item rounded-md state-effects"
    :class="!canAdd ? 'cursor-not-allowed' : 'cursor-pointer'"
    @click="type === 'add' && canAdd ? emit('click:add', { email } as IGenericUser) : null"
  >
    <UserAvatar class="mr-md !size-button" :user="null" />
    <div class="flex flex-col flex-grow">
      <div class="text-wrap break-all w-full font-semibold">
        {{ email }}
      </div>
      <span v-if="hasSeatsAvailable(SeatType.user)" class="text-muted">
        {{ $t('general.willBeInvited') }}
      </span>
      <NoSeatsAvailableForInvitation v-else class="mt-sm" />
    </div>
    <IconButton
      v-if="type === 'add' && canAdd"
      :icon-name="EIcon.PLUS"
      theme="primary-filled"
      class="h-button w-button"
      @click="emit('click:add', { email } as IGenericUser)"
    />
  </div>
</template>
